<template>
  <div class="card p-3 container-card--preview">
    <div class="card-body p-3 bg-white">
      <div class="input-group input-group-lg">
        <input type="text" placeholder="Correo electrónico" class="form-control mb-2">
      </div>
      <div class="input-group input-group-lg mb-2">
        <input type="text" placeholder="Nombre y Apellido" class="form-control">
      </div>
      <div class="d-flex flex-column flex-md-row mb-2">
        <div class="input-group input-group-lg">
          <div class="input-group-prepend">
            <span class="input-group-text" id="inputGroup-sizing-lg">+56</span>
          </div>
          <input type="text" class="form-control" placeholder="Teléfono" aria-describedby="inputGroup-sizing-lg">
        </div>
        <div class="input-group input-group-lg ml-1">
          <input type="text" placeholder="Rut" class="form-control">
        </div>
      </div>
      <!-- <div class="d-flex mb-2">
        <div class="d-flex align-items-center">
          <circle-icon size="1.5x"></circle-icon>&nbsp;
          <label>Requiero boleta</label>
        </div>
        <div class="ml-2 d-flex align-items-center">
          <circle-icon size="1.5x"></circle-icon>&nbsp;
          <label>Requiero factura</label>
        </div>
      </div> -->
      <div class="w-full text-right mt-4">
        <button type="button"
          disabled
          class="button-preview__continue"
          :style="{ backgroundColor: buttonsColor }"
        >
          Continuar
        </button>
      </div>
    </div>
  </div>
</template>
<script>
// import { CircleIcon } from 'vue-feather-icons'
export default {
  name: 'PreviewTabIdentification',
  components: {
    // CircleIcon
  },
  props: {
    buttonsColor: {
      type: String,
      default: 'dark'
    }
  }
}
</script>
<style scoped>
.container-card--preview {
  background-color: #F2F4F4;
  height: 500px;
  width: 700px;
  max-width: 700px;
}
.button-preview__continue {
  padding: 8px 22px;
  border: 8px;
  color: white;
  border-radius: 6px;
}
</style>